import React from 'react';
import { makeStyles, Image, Text, tokens } from '@fluentui/react-components';
import RestrictedPlaceholder from '../assets/restricted.svg';

const useStyles = makeStyles({
  errorPageContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  noResultWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '100px',
  },
  noResultFirstRow: {
    marginTop: tokens.spacingVerticalXXL,
    fontWeight: tokens.fontWeightRegular,
    fontSize: tokens.fontSizeBase600,
    lineHeight: tokens.lineHeightHero700,
  },
});

const ErrorPage = () => {
  const classes = useStyles();
  return (
    <div className={classes.errorPageContainer}>
      <div className={classes.noResultWrapper}>
        <Image src={RestrictedPlaceholder} height="200" width="222" />
        <Text className={classes.noResultFirstRow}>Something went wrong. Please refresh the page and try again.</Text>
      </div>
    </div>
  );
};

export const StyledErrorPage = ErrorPage;
